export const FINANCING_DATA = {
  affirm: {
    id: 'affirm',
    img: '/financings/affirm-financing.svg',
    bullets: [
      {
        title: 'Flexible Payment Plans',
        description: 'Interest-free and longer-term options available',
      },
      {
        title: 'No Credit Impact',
        description: "Checking eligibility won't affect your credit score",
      },
      {
        title: 'Instant Decisions',
        description: 'Real-time approvals for a quick checkout',
      },
    ],
    legal: 'Excluded locations: Massachusetts, New York',
    modal: {
      subtitle: 'Buy Now, Pay Later with Affirm',
      items: [
        {
          icon: '/affirm-credit-card.svg',
          title: 'Apply for Affirm Virtual Card',
          subtitle:
            'Download the Affirm app and apply for a one-time use virtual card.',
        },
        {
          icon: '/affirm-invoice.svg',
          title: 'Get Your Invoice',
          subtitle:
            'If approved, contact our customer service for an invoice of the total price.',
        },
        {
          icon: '/affirm-success-circle-icon.svg',
          title: 'Pay Your Invoice',
          subtitle: 'Use your Affirm virtual card to pay the full invoice.',
        },
      ],
      link: 'https://www.affirm.com/shopping/virtual-card',
      color: '#4A4AF4',
      buttonLabel: 'Apply for Affirm Virtual Card',
    },
  },
  terrace: {
    id: 'terrace',
    img: '/financings/terrace-big-logo.svg',
    bullets: [
      {
        title: 'Multiple Lenders',
        description: 'Compare offers from a broad lending network',
      },
      {
        title: 'Tailored Options',
        description: 'Get matched with financing fit for your needs',
      },
      {
        title: 'Guided Support',
        description: 'Dedicated customer service throughout the process',
      },
    ],
    legal:
      'Excluded Locations: California, Colorado, Illinois, Virginia, New Jersey, Massachusetts, Connecticut, Maryland, Nevada, Washington, Wisconsin, West Virginia, Minnesota, New York, Vermont',
    modal: {
      subtitle: 'Buy Now, Pay Later with Terrace Finance',
      items: [
        {
          icon: '/terrace-form-icon.svg',
          title: 'Apply for Financing',
          subtitle: 'Get approved with Terrace Finance.',
        },
        {
          icon: '/terrace-invoice-icon.svg',
          title: 'Get Your Quote',
          subtitle:
            'Contact our customer service with your puppy selection to receive a complete quote.',
        },
        {
          icon: '/terrace-contract-icon.svg',
          title: 'E-Sign',
          subtitle:
            'Receive and e-sign your contract from Terrace to complete your purchase.',
        },
      ],
      link: 'https://terracefinanceapp.azurewebsites.net/onlineApplication/preApplication?source=1&identifier=2970',
      color: '#0052A4',
      buttonLabel: 'Apply with Terrace Finance',
    },
  },
  mawoo: {
    id: 'mawoo',
    img: '/mawoo-logo-mobile.svg',
    bullets: [
      {
        title: 'Simple Payment Plan',
        description: 'Make an upfront payment, then four easy installments',
      },
      {
        title: 'Available to Everyone',
        description: 'Custom plans are available for all customers',
      },
      {
        title: 'No Credit Checks',
        description: 'Payment plans are not subject to credit checks. ',
      },
    ],
    legal: null,
    modal: {
      subtitle: 'Pay Over Time with Mawoo',
      items: [
        {
          icon: '/terrace-form-icon.svg',
          title: 'Get your quote',
          subtitle:
            'Contact our team to find out your upfront payment and monthly installment amounts.',
        },
        {
          icon: '/terrace-invoice-icon.svg',
          title: 'Make You Upfront Payment',
          subtitle: 'Pay part of the price to reserve your puppy.',
        },
        {
          icon: '/terrace-contract-icon.svg',
          title: 'Pay Rest in 4',
          subtitle: 'Pay the remaining balance in 4 payments over 2 months.',
        },
      ],
      link: 'tel:+18884887203',
      color: '#243547',
      buttonLabel: 'Get a Quote',
    },
  },
  acorn: {
    id: 'acorn',
    img: '/logos/acorn.png',
    bullets: [
      {
        title: 'Pre-Qualify in Minutes',
        description: 'Receive offers in 60 seconds or less ',
      },
      {
        title: 'No Credit Impact',
        description: "Checking eligibility doesn't affect your credit score",
      },
      {
        title: 'Competitive Rates',
        description: 'Access a range of APRs as low as 6.99%',
      },
    ],
    legal: null,
    modal: {
      subtitle: 'Buy Now, Pay Later with Acorn Finance',
      items: [
        {
          icon: '/terrace-form-icon.svg',
          title: 'Apply for Financing',
          subtitle: 'Get approved with Acorn Finance.',
        },
        {
          icon: '/terrace-invoice-icon.svg',
          title: 'Get Your Quote',
          subtitle:
            'Contact our customer service with your puppy selection to receive a complete quote.',
        },
        {
          icon: '/terrace-contract-icon.svg',
          title: 'E-Sign',
          subtitle:
            'Receive and e-sign your contract from Acorn to complete your purchase.',
        },
      ],
      link: 'https://www.acornfinance.com/pre-qualify/?d=P5AHQ&utm_medium=web_pre_qual_link_copy_welcome',
      color: '#243547',
      buttonLabel: 'Apply with Acorn Finance',
    },
  },
}

export const FINANCING_OPTIONS = Object.fromEntries(
  Object.entries(FINANCING_DATA).map(([key, value]) => [
    key,
    {
      image: value.img,
      ...value.modal,
    },
  ])
)

export const FINANCING_CARDS = Object.values(FINANCING_DATA).map((item) => ({
  id: item.id,
  modal: item.id as 'affirm' | 'credova' | 'terrace' | 'mawoo',
  img: item.img,
  bullets: item.bullets,
  legal: item.legal,
}))

export const WHY_A_PLAN = [
  {
    title: 'Spread your costs',
    description:
      'Avoid paying everything upfront. Instead spread your cost over months with a payment plan.',
  },
  {
    title: '0% APR options',
    description:
      'Opt for 0% interest with select financing options; make your purchase more affordable.',
  },
  {
    title: 'No credit check',
    description:
      'No hard credit check is performed meaning no impact on your credit score.',
  },
]
